export default "__VITE_ASSET__7a28bb18__"